/*
 * (c) Copyright, 2025, Medidata Solutions Worldwide, Inc. All rights reserved.
 */

import React, { useState } from 'react'
import { useServiceContext } from '../../../root'
import ActionsMenuBig from '../../../components/shared/ActionsMenuBig'
import { useModal } from '../../../contexts/ModalContext'
import EditPackageModal from '../../../components/etmf/edit-package-modal'
import { EtmfListView, type MasterDataTypeValue } from '~/constants/etmf'
import ModalImport from '~/components/modals/ModalImport'
import AddDocumentModal from '~/pages/browser/add-document/add-new-document/AddDocumentModal'
import AddMasterDataModal from './AddMasterDataModal'

interface EtmfPageMenuProps {
  actions: {
    title: string
    filterLabel: string
    addNewMDF: string
  }
  listView: string
  onPackageChange?: () => void
}

const EtmfPageMenu: React.FC<EtmfPageMenuProps> = ({ actions, listView, onPackageChange }) => {
  const context = useServiceContext()
  const { showModal } = useModal()
  const [isShowImportPackageModal, setIsShowImportPackageModal] = useState(false)
  const { translate } = context.service.filter

  const handleAdd = async () => {
    if (listView === EtmfListView.PACKAGE) {
      showModal(<EditPackageModal onClose={onPackageChange} />)
    } else if (listView === EtmfListView.FILE_PLAN) {
      try {
        const data = await context.api.etmf.getLinkedEntities()
        showModal(
          <AddDocumentModal
            filePlan={true}
            docId={Number(data.entityLinkMap.FILE_PLAN_DOC_TYPE)}
            parentId={Number(data.entityLinkMap.FILE_PLAN_FOLDER)}
          />
        )
      } catch (error) {
        console.error('Failed to load linked entities:', error)
      }
    } else {
      showModal(<AddMasterDataModal type={listView as MasterDataTypeValue} />)
    }
  }

  const settings = {
    menuId: 'page',
    items: [
      {
        value: translate(actions.addNewMDF),
        action: handleAdd
      },
      ...(listView === EtmfListView.PACKAGE
        ? [
            {
              value: 'IMPORT_PACKAGES',
              action: function () {
                setIsShowImportPackageModal(true)
              }
            },
            {
              value: 'EXPORT_PACKAGES',
              action: function () {
                context.api.settings.exportSettingsData(context.constant.etmf.PACKAGES, undefined, undefined, translate)
              }
            }
          ]
        : [])
    ]
  }

  return (
    <>
      <div>
        <ActionsMenuBig {...settings} />
      </div>
      <ModalImport
        importType={context.constant.etmf.PACKAGES}
        onClose={() => {
          setIsShowImportPackageModal(false)
          onPackageChange?.()
        }}
        show={isShowImportPackageModal}
      />
    </>
  )
}

export default EtmfPageMenu
